<template>
  <section>
    <modal v-cloak v-model="modalVisible" title="Change Password" @show="onShow" :footer="false">
      <div class="row row-margin">
        <div class="col-sm-offset-2 col-sm-8">
          <error-list v-if="errorObject" :error-object="errorObject"/>

          <form v-show="submitted == 0" @submit.prevent.stop="submit">
            <div class="form-group">
              <label>Current Password</label>
              <input type="password" v-model="currentPassword" class="form-control input-sm" placeholder="Current Password">
            </div>
            <div class="form-group" :class="{ 'has-error': $v.password.$error }">
              <label>New Password</label>
              <input type="password" v-model="password" class="form-control input-sm" placeholder="New Password">
              <span
                  v-show="$v.password.$error"
                  class="help-block">
                  The password must be at least 8 characters.
              </span>
            </div>
            <div class="form-group" :class="{ 'has-error': $v.passwordConfirmation.$error }">
              <label>Confirm New Password</label>
              <input type="password" v-model="passwordConfirmation" class="form-control input-sm" placeholder="Confirm New Password">
              <span
                  v-show="$v.passwordConfirmation.$error"
                  class="help-block">
                  Please enter the same value again.
              </span>
            </div>
            <button class="btn btn-primary btn-sm btn-text pull-right" @click.prevent.stop="submit">
              Change Password
            </button>
            <div class="clearfix"></div>
          </form>
          <div class="vue-modal-success" v-show="submitted == 1">Processing...</div>
        </div>
      </div>
    </modal>
  </section>
</template>

<style scoped>
</style>

<script>
import { Modal } from 'uiv'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import ErrorList from "../ErrorList"
import { ErrorListMixin }  from '../../mixins/ErrorListMixin'
import { ModalMixin } from '../../mixins/ModalMixin'

export default {
    components: {
        'error-list': ErrorList,
        'modal': Modal,
    },

    mixins: [ErrorListMixin, ModalMixin],

    props: {
        modalName: {
            type: String,
            default: 'changePassword'
        },
    },

    data () {
        return {
            currentPassword: null,
            password: null,
            passwordConfirmation: null,
        }
    },

    validations: {
        currentPassword: {
            required,
        },
        password: {
            required,
            minLength: minLength(8),
        },
        passwordConfirmation: {
            required,
            sameAs: sameAs('password'),
        },
    },

    methods: {
        prepSubmission: function () {
            this.$v.$reset()
            this.prepErrorList()
        },

        onShow: function () {
            this.currentPassword = null
            this.password = null
            this.passwordConfirmation = null
            this.errorObject = null
            this.prepSubmission()
        },

        submit: async function () {
            this.$v.$touch()
            if (!this.$v.$error) {
                const self = this
                this.postAndErrorCheck('/account/change-password', {
                    current_password: this.currentPassword,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                }, function() { self.modalVisible = false }, this.prepSubmission)
            }
        },
    },
}
</script>
